import React from 'react';
import { Artifact } from '../../../types/artifact';

interface ImageArtifactViewerProps {
  artifact: Artifact;
}

export const ImageArtifactViewer: React.FC<ImageArtifactViewerProps> = ({ artifact }) => {
  const getImageUrl = (): string => {
    if (typeof artifact.content === 'string') {
      // Check if it's a data URL or a regular URL
      if (artifact.content.startsWith('data:') || artifact.content.startsWith('http')) {
        return artifact.content;
      }
    }
    
    if (typeof artifact.content === 'object' && artifact.content.url) {
      return artifact.content.url;
    }
    
    // Fallback to metadata
    if (artifact.metadata?.url) {
      return artifact.metadata.url;
    }
    
    return '';
  };
  
  const imageUrl = getImageUrl();
  
  if (!imageUrl) {
    return (
      <div className="text-center py-8 text-gray-500">
        Image data not available
      </div>
    );
  }
  
  return (
    <div className="image-artifact-viewer">
      <div className="flex justify-center">
        <img 
          src={imageUrl} 
          alt={artifact.name} 
          className="max-w-full max-h-[600px] object-contain"
        />
      </div>
      
      {artifact.content.description && (
        <div className="mt-4 text-center text-gray-700">
          {artifact.content.description}
        </div>
      )}
    </div>
  );
};
